import React, { useRef, useMemo } from "react";
import { useFrame } from "@react-three/fiber";
import * as THREE from "three";
import { bgVertex, bgFragment } from "./shaders";
import { scrollState, getDarkness } from "./scrollMath";

export default function Background() {
  const matRef = useRef();
  const uniforms = useMemo(
    () => ({
      uDark: { value: 0 },
      uTime: { value: 0 },
      uCream: { value: new THREE.Color("#F5F0E8") },
      uBlack: { value: new THREE.Color("#0A0A0A") },
      uRed: { value: new THREE.Color("#E45F6A") },
    }),
    []
  );
  useFrame((state) => {
    if (!matRef.current) return;
    matRef.current.uniforms.uDark.value = getDarkness(scrollState.progress);
    matRef.current.uniforms.uTime.value = state.clock.elapsedTime;
  });
  return (
    <mesh frustumCulled={false} renderOrder={-10}>
      <planeGeometry args={[2, 2]} />
      <shaderMaterial
        ref={matRef}
        vertexShader={bgVertex}
        fragmentShader={bgFragment}
        uniforms={uniforms}
        depthTest={false}
        depthWrite={false}
      />
    </mesh>
  );
}
